import customAxios from "../utils/customAxios";

export interface NotificationItem {
  id_notification: number;
  type: string;
  title: string;
  message: string;
  data?: Record<string, any>;
  isRead: boolean;
  relatedEntityId?: string;
  relatedEntityType?: string;
  created_at: string;
  updated_at: string;
}

interface NotificationsResponse {
  notifications: NotificationItem[];
  total: number;
  unreadCount: number;
}

export const getNotifications = async (
  page = 1,
  limit = 20,
): Promise<NotificationsResponse> => {
  try {
    const response = await customAxios.get("/notifications", {
      params: { page, limit },
    });
    return {
      notifications: response.data.notifications || [],
      total: response.data.total || 0,
      unreadCount: response.data.unreadCount || 0,
    };
  } catch (error: any) {
    return { notifications: [], total: 0, unreadCount: 0 };
  }
};

export const getUnreadCount = async (): Promise<{
  success: boolean;
  unreadCount: number;
}> => {
  try {
    const response = await customAxios.get("/notifications/unread-count");
    return { success: true, unreadCount: response.data.unreadCount || 0 };
  } catch {
    return { success: false, unreadCount: 0 };
  }
};

export const markNotificationAsRead = async (notificationId: number) => {
  try {
    await customAxios.patch(`/notifications/${notificationId}/read`);
    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    await customAxios.patch("/notifications/mark-all-read");
    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};

export const deleteNotification = async (notificationId: number) => {
  try {
    await customAxios.delete(`/notifications/${notificationId}`);
    return { success: true };
  } catch (error: any) {
    return { success: false };
  }
};
